"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PHYSICS_GRAVITY = void 0;
exports.PHYSICS_GRAVITY = { x: 0, y: -150, z: 0 };
